import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36f50564"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-wrap"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fecha:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Puntos:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Rondas:", -1))

import { Torneo } from "@/interfaces/Torneo";
import { formatFechaSpa } from "@/utils/Fecha";
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'TorneoCard',
  props: {
    torneo: {},
    verClasificacion: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const router = useRouter();
const fechaTorneo = ref<string>("");

// Variables reactivas
const formattedAddress = ref<string>("");

// Computed property para generar el enlace a Google Maps
const googleMapsUrl = computed(() => {
  if (!props.torneo.lugarTorneo) return "#";
  return `https://www.google.com/maps?q=${parseFloat(
    props.torneo.lugarTorneo.split(", ")[0]
  )},${parseFloat(props.torneo.lugarTorneo.split(", ")[1])}`;
});

// Función para obtener dirección inversa desde coordenadas
const getAddress = async (lat: number, lon: number) => {
  const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`;
  try {
    const response = await fetch(url);
    const data = await response.json();

    if (data.address) {
      const { road, house_number, city, town, village, state, postcode } =
        data.address;

      // Priorizar ciudad, pueblo o aldea
      const locationCity = city || town || village || "";

      // Construir dirección formateada
      formattedAddress.value = [
        road ? `${road}${house_number ? `, ${house_number}` : ""}` : "",
        locationCity,
        state,
        postcode,
      ]
        .filter(Boolean) // Eliminar valores vacíos
        .join(", "); // Unir con comas
    } else {
      formattedAddress.value = "Dirección no disponible";
    }
  } catch (error) {
    console.error("Error obteniendo la dirección:", error);
  }
};
const isValidCoordinates = (value: string): boolean => {
  if (!value) return false;

  // Expresión regular para validar coordenadas (lat, lng)
  const regex = /^-?\d{1,2}\.\d+,\s*-?\d{1,3}\.\d+$/;

  return regex.test(value.trim());
};

onMounted(async () => {
  fechaTorneo.value = await formatFechaSpa(props.torneo.fechaInicioTorneo);
  if (isValidCoordinates(props.torneo.lugarTorneo)) {
    getAddress(
      parseFloat(props.torneo.lugarTorneo.split(", ")[0]),
      parseFloat(props.torneo.lugarTorneo.split(", ")[1])
    );
  }
});

const goToDetalle = () => {
  router.push(`/detalle-torneo/${props.torneo.idTorneo}`);
};
const goToResultadoTorneo = () => {
  if (
    props.torneo.tipoTorneo == "Individual" &&
    props.torneo.listasPorJugador > 1
  )
    router.push(`/detalle-torneo-live-mas/${props.torneo.idTorneo}`);
  else router.push(`/detalle-torneo-live/${props.torneo.idTorneo}`);
};

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "pa-3" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_img, {
        src: _ctx.torneo.cartelTorneo || require('@/assets/images/cartelMissing.jpg'),
        height: "250px",
        class: "rounded-lg"
      }, null, 8, ["src"]),
      _createVNode(_component_v_divider, { class: "my-3" }),
      _createVNode(_component_v_card_title, { class: "ringbearer text-h6 text-center text-wrap font-weight-bold mt-3" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.torneo.nombreTorneo), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_subtitle, { class: "text-center mb-3" }, {
        default: _withCtx(() => [
          (formattedAddress.value.trim())
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                _createVNode(_component_v_icon, {
                  left: "",
                  class: "location-icon"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-map-marker")
                  ]),
                  _: 1
                }),
                _createElementVNode("a", {
                  href: googleMapsUrl.value,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, _toDisplayString(formattedAddress.value), 9, _hoisted_2)
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_3, [
                _createVNode(_component_v_icon, {
                  left: "",
                  class: "location-icon"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-map-marker")
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.torneo.lugarTorneo), 1)
              ]))
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider, { class: "my-3" }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "10",
                offset: "1",
                class: "text-left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, [
                    _createVNode(_component_v_icon, {
                      left: "",
                      color: "green"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-calendar")
                      ]),
                      _: 1
                    }),
                    _hoisted_4,
                    _createTextVNode(" " + _toDisplayString(fechaTorneo.value) + " a las " + _toDisplayString(_ctx.torneo.horaInicioTorneo), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _createVNode(_component_v_icon, { color: "cyan" }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-trophy")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(),
                    _hoisted_5,
                    _createTextVNode(" " + _toDisplayString(_ctx.torneo.puntosTorneo), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _createVNode(_component_v_icon, { color: "cyan" }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-format-list-bulleted")
                      ]),
                      _: 1
                    }),
                    _hoisted_6,
                    _createTextVNode(" " + _toDisplayString(_ctx.torneo.numeroPartidas), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider, { class: "mb-3" }),
      _createVNode(_component_v_card_actions, { class: "d-flex justify-space-between" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "tonal",
                    color: "orange lighten-2",
                    onClick: goToDetalle
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Detalle ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "tonal",
                    color: "blue lighten-2",
                    onClick: goToResultadoTorneo
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Resultados ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})